export default __webpack_public_path__ + "static/media/default-header-background-desktop.8209c6b2.svg";